import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/purchaseOrder/schema";
import { purchasingTransactionBeforeSave } from "services/sosInventoryService/purchasingTransaction/beforeSave";
import {
  normalizeTaxAmount,
  normalizeDateFields,
} from "services/utility/beforeSave";

import { OBJECT_TYPES } from "appConstants";

const OBJECT_TYPE = OBJECT_TYPES.PURCHASE_ORDER.fullString;

export function beforeSave(record) {
  const newRecord = purchasingTransactionBeforeSave(OBJECT_TYPE, record);

  newRecord.taxAmount = normalizeTaxAmount(newRecord.totals.tax);
  delete newRecord.totals;

  return normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);
}
